var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarMarketplaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3628 19.5525C18.4503 19.5525 19.3319 18.6709 19.3319 17.5834C19.3319 16.4959 18.4503 15.6143 17.3628 15.6143C16.2753 15.6143 15.3937 16.4959 15.3937 17.5834C15.3937 18.6709 16.2753 19.5525 17.3628 19.5525Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5868 8.32862C29.6743 8.32862 30.5559 7.44701 30.5559 6.3595C30.5559 5.27199 29.6743 4.39038 28.5868 4.39038C27.4993 4.39038 26.6177 5.27199 26.6177 6.3595C26.6177 7.44701 27.4993 8.32862 28.5868 8.32862Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5868 30.7766C29.6743 30.7766 30.5559 29.895 30.5559 28.8075C30.5559 27.72 29.6743 26.8384 28.5868 26.8384C27.4993 26.8384 26.6177 27.72 26.6177 28.8075C26.6177 29.895 27.4993 30.7766 28.5868 30.7766Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2123 19.5525C32.2998 19.5525 33.1814 18.6709 33.1814 17.5834C33.1814 16.4959 32.2998 15.6143 31.2123 15.6143C30.1248 15.6143 29.2432 16.4959 29.2432 17.5834C29.2432 18.6709 30.1248 19.5525 31.2123 19.5525Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3628 5.70313C18.4503 5.70313 19.3319 4.82153 19.3319 3.73401C19.3319 2.6465 18.4503 1.76489 17.3628 1.76489C16.2753 1.76489 15.3937 2.6465 15.3937 3.73401C15.3937 4.82153 16.2753 5.70313 17.3628 5.70313Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51337 19.5525C4.60088 19.5525 5.48249 18.6709 5.48249 17.5834C5.48249 16.4959 4.60088 15.6143 3.51337 15.6143C2.42586 15.6143 1.54425 16.4959 1.54425 17.5834C1.54425 18.6709 2.42586 19.5525 3.51337 19.5525Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3628 33.4021C18.4503 33.4021 19.3319 32.5205 19.3319 31.433C19.3319 30.3455 18.4503 29.4639 17.3628 29.4639C16.2753 29.4639 15.3937 30.3455 15.3937 31.433C15.3937 32.5205 16.2753 33.4021 17.3628 33.4021Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13886 8.32862C7.22637 8.32862 8.10798 7.44701 8.10798 6.3595C8.10798 5.27199 7.22637 4.39038 6.13886 4.39038C5.05134 4.39038 4.16974 5.27199 4.16974 6.3595C4.16974 7.44701 5.05134 8.32862 6.13886 8.32862Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13886 30.7766C7.22637 30.7766 8.10798 29.895 8.10798 28.8075C8.10798 27.72 7.22637 26.8384 6.13886 26.8384C5.05134 26.8384 4.16974 27.72 4.16974 28.8075C4.16974 29.895 5.05134 30.7766 6.13886 30.7766Z",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.755 18.9756L24.2876 24.5082L27.1946 27.4152",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 16.1914L10.4381 10.6588L7.53104 7.75171",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 18.9756L10.4381 24.5082L7.53104 27.4152",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.755 16.1914L24.2876 10.6588L27.1946 7.75171",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 5.12622L10.4381 10.6588L4.90555 16.1914",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.755 30.0407L24.2876 24.5082L29.8201 18.9756",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8201 16.1914L24.2876 10.6588L18.755 5.12622",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 30.0407L10.4381 24.5082L4.90555 18.9756",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2432 17.5835H19.332",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3937 17.5835H5.48248",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3629 29.4637V19.5525",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3629 15.6144V5.70312",
    stroke: "black",
    strokeWidth: 1.96912,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarMarketplaceIcon);
export default __webpack_public_path__ + "static/media/solar-marketplace-icon.6224445c3c91963f4304e93f0eedade4.svg";
export { ForwardRef as ReactComponent };